import {Navigate, useLocation} from "react-router-dom";
import useAuth from "../auth/useAuth";

function RequireAuth({ children, egiftOnly = false }) {
  const { authed, egifted } = useAuth();
  const location = useLocation();

  return authed ? (
      egiftOnly ? (
          egifted ? (
            children
          ) : (
            <Navigate to="/login/" replace state={{ path: location.pathname }} />
          )
      ) : (
        egifted ? (
          <Navigate to="/login/" replace state={{ path: location.pathname }} />
        ) : (
          children
        )
      )
  ) : (
    <Navigate to="/login/" replace state={{ path: location.pathname }} />
  );
}
export default RequireAuth;